import { getProjectNameList } from './api-path';

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const ignoreCancel = [getProjectNameList];
